import Button from 'components/Button';
import Loading from 'components/Loading';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import config from 'config';
import Warning from '../../../../components/Warning/index';
import PersonalDataTable from 'modules/Profile/components/PersonalData/components/PersonalDataTable';
import AvatarComponent from 'modules/Profile/components/PersonalData/components/AvatarComponent';
import TaxExemptionsList from 'modules/Profile/components/PersonalData/components/TaxExemptionsList';
import ArmyMobilizedSupport from 'modules/Profile/components/PersonalData/components/ArmyMobilizedSupport';
import BiggestStatus from 'modules/Profile/components/PersonalData/components/BiggestStatus';
import InnCertificate from 'modules/Profile/components/PersonalData/components/InnSertificate';

export default class PersonalData extends Component {
  componentDidMount() {
    this.props.personalDataPageInit();
  }

  renderLoading = () => {
    return (
      <div className="loading-container loading-container__middle">
        <Loading />
      </div>
    );
  };

  render() {
    const {
      isLoading,
      isError,
      userInfo,
      personalData,
      avatar,
      isReadOnly,
      goToChangePersData,
      inn,
      loadAvatar,
      taxExemptions,
    } = this.props;

    if (isError) {
      return <Warning />;
    }
    if (isLoading) {
      return (
        <div className="loading-container loading-container__middle">
          <Loading />
        </div>
      );
    }

    const isArmyMobilized = userInfo.get('isArmyMobilized');

    return (
      <div className="white-block__pad40 pt-0 profile_data boo">
        <div className="row page_margin40">
          <div className="col col-md-auto">
            <AvatarComponent avatar={avatar} isReadOnly={isReadOnly} loadAvatar={loadAvatar} />
          </div>
          <div className="col-12 col-md order-md-first">
            <PersonalDataTable personalData={personalData} inn={inn} />
          </div>
        </div>
        {config.isInspectorArm || isReadOnly ? null : (
          <div className="page_margin40">
            <Button
              value="Уточнить персональные данные"
              size="medium"
              color="orange"
              type="button"
              onClick={goToChangePersData}
              hasWrapper={false}
            />
          </div>
        )}
        <InnCertificate hideLink={config.isInspectorArm} />
        <BiggestStatus />
        <TaxExemptionsList taxExemptions={taxExemptions} />

        {isArmyMobilized && <ArmyMobilizedSupport />}
      </div>
    );
  }
}
PersonalData.propTypes = {
  avatar: PropTypes.string,
  personalData: PropTypes.object,
  userInfo: PropTypes.object,
  taxExemptions: PropTypes.array,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  goToChangePersData: PropTypes.func,
  personalDataPageInit: PropTypes.func,
  isReadOnly: PropTypes.bool,
  inn: PropTypes.string,
  loadAvatar: PropTypes.func,
};
